<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.transport'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('transport')
    }
  },
  methods: {
    ...mapMutations([
      'selectTransportStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectTransportStatus(1);
      this.transport = 1
    },
    chooseMedium: function () {
      this.selectTransportStatus(2);
      this.transport = 2
    },
    chooseTop: function () {
      this.selectTransportStatus(3);
      this.transport = 3
    }
  },
};
</script>
<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="transport < 2"
        class="question_image question_image_transport-basic d-block d-sm-none"
      ></div>
      <div v-else-if="transport == 2"
        class="question_image question_image_transport-medium d-block d-sm-none"
      ></div>
      <div v-else-if="transport == 3"
        class="question_image question_image_transport-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('transport')"
      :imageName="questionAnswerData.images.Q6AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('transport')"
      :imageName="questionAnswerData.images.Q6AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('transport')"
      :imageName="questionAnswerData.images.Q6AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        class='answer-transport-basic'
        :isSelected="transport == 1"
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        class='answer-transport-medium'
        :isSelected="transport == 2"
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        class='answer-transport-top'
        :isSelected="transport == 3"
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('transport')">next</MDBBtn>
    </div>
  </QuestionPage>
</template>


